import {
    API_ROOT
}from 'apiConfig'

export default{
    sides:[{
        title: '基础服务',
        children:[{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/home_page.png'),
            title: '个人主页',
            path: '/'
        },{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/my_trade.png'),
            title: '我的交易',
            path: '/myTrade'
        },{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/account.png'),
            title: '我的账户',
            path: '/myAccount'
        },{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/my_focus.png'),
            title: '我的关注',
            path: '/myFocus'
        },{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/collect.png'),
            title: '我的收藏',
            path: '/myCollection'
        },{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/ask.png'),
            title: '我的提问',
            path: '/myAsk'
        },{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/my_follow.png'),
            title: '我的跟单',
            path: '/myFollows'
        },{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/config.png'),
            title: '个人设置',
            path: '/myConfig'
        }]
    },
    {
        title: '分析师服务',
        children:[{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/expert_page.png'),
            title: '专家主页',
            path: '/analystHome'
        },{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/content_manage.png'),
            title: '内容管理',
            path: '/contentManage'
        },{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/salon.png'),
            title: '沙龙坐堂',
            path: '/salonHall'
        },{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/teach.png'),
            title: '专家答疑',
            path: '/salonQuestions'
        },{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/information.png'),
            title: '认证信息',
            path: '/profileInfo'
        }]
    },{
        title: '经纪商管理',
        children:[{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/expert_page.png'),
            title: '机构主页',
            path: '/brokerHome'
        },{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/broker_content_manage.png'),
            title: '内容管理',
            path: '/brokerContentManage'
        },{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/broker_ad_upload.png'),
            title: '广告投放',
            path: '/brokerAds'
        },{
            imgUrl: API_ROOT.concat('/assets/ucenter/images/broker_profile_info.png'),
            title: '认证信息',
            path: '/brokerProfileInfo'
        }]
    }],
    tabs:[{
        title: '主要'
    },{
        title: '外汇'
    },{
        title: '贵金属'
    },{
        title: '指数'
    }],
    tradeTabs:[{
        title: '我的持仓'
    },{
        title: '历史记录'
    }],
    directions:[{
        key: '全部',
        value: null
    },{
        key: '买入',
        value: 0
    },{
        key: '卖出',
        value: 1
    }],
    followTypes:[{
        key: '全部',
        value: null
    },{
        key: '自主',
        value: 0
    },{
        key: '跟单',
        value: 1
    },{
        key: '跟开自平',
        value: 2
    }],
    accountTabs:[{
        title: '我的账户'
    },{
        title: '绑定新账户'
    },{
        title: '开立新账户'
    }],
    accountTypes:[{
        key:'真实账户',
        value: '2'
    }],
    platformTypes:[{
        key: 'MT4',
        value: '1'
    }],
    focusTabs:[{
        title: '我的关注'
    }],
    collectTabs:[{
        title: '我的收藏'
    }],
    askTabs:[{
        title: '我的提问'
    }],
    orderTabs:[{
        title: '我的跟单'
    }],
    configTabs:[{
        title: '个人资料'
    },{
        title: '安全设置'
    }],
    publishTabs:[{
        title: '发表文章'
    },{
        title: '发表动态'
    }],
    manageTabs:[{
        title: '已发布文章'
    },{
        title: '待发布文章'
    },{
        title: '已发布动态'
    }],
    profileTabs:[{
        title: '认证信息'
    }],
    brokerPublishTabs:[{
        title: '发表文章'
    }],
    brokerContentTabs:[{
        title: '已发布文章'
    },{
        title: '待发布文章'
    }],
    brokerAdTabs:[{
        title: '广告投放'
    }],
    salonHallTabs:[{
        title: '坐堂安排'
    },{
        title: '沙龙回顾'
    }],
    salonAnswersTabs:[{
        title: '回答提问'
    }],
    salonReviewTabs:[{
        title: '全部问答'
    },{
        title: '未回答提问'
    }],
    salonArrangeTabs:[{
        title: '全部问答'
    },{
        title: '未回答提问'
    }],
    salonUnStartTabs:[{
        title: '全部问答'
    }],
    sexs:[{
        name: '男',
        value: '1'
    },{
        name: '女',
        value: '2'
    }],
    types:[{
        name: '黄金投资分析师执业资格',
        value: '1'
    },{
        name: '外汇投资分析师执业资格',
        value: '2'
    }],
    goldJobs:[{
        key: '助理黄金投资分析师',
        value: '1'
    },{
        key: '中级黄金投资分析师',
        value: '2'
    },{
        key: '高级黄金投资分析师',
        value: '3'
    }],
    forexJobs:[{
        key: '中级外汇投资分析师',
        value: '4'
    },{
        key: '高级外汇投资分析师',
        value: '5'
    }],
    tradeVarieties:[{
        code: '1',
        name: '外汇'
    },{
        code: '2',
        name: '贵金属'
    },{
        code: '3',
        name: 'CFD'
    },{
        code: '4',
        name: '指数'
    }],
    platforms:[{
        code: '1',
        name: 'MT4'
    },{
        code: '2',
        name: 'MT5'
    },{
        code: '3',
        name: '其他平台'
    }],
    commissionMethods:[{
        value: '1',
        key: '市价'
    }],
    uploadMsg: '无居民身份证的内地居民可提交【临时居民身份证】，香港、澳门特别行政区、台湾居民提供当地有效身份证件。<br/>照片或扫描件必须本人手持身份证，保证头像清晰可辨认，保证身份证信息清晰可见。<br/>格式要求：支持jpg  jpeg  png 格式照片，大小不超过2M。'
}



// WEBPACK FOOTER //
// ./src/service/ucenter/datas.js